export default {
  metadata: {
    version: '1.0.0',
    id: 'table-cell-1.0.0',
    name: 'JDSTableCell'
  },
  hierarchy: {
    container: ['jds-text']
  },
  base: {
    container: {
      'flex-direction': '{t_0}',
      'justify-content': '{t_1}',
      'align-items': '{t_2}',
      'background-color': '{t_3}',
      'padding-left': '{t_4}',
      'padding-right': '{t_5}',
      'padding-top': '{t_6}',
      'padding-bottom': '{t_7}',
      'border-color': '{t_8}',
      'border-bottom-width': 1,
      width: '{size.max}'
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1
    }
  },
  variant: {
    density: {
      condensed: {
        container: {
          'padding-left': '{t_9}',
          'padding-right': '{t_10}',
          'padding-top': '{t_11}',
          'padding-bottom': '{t_12}'
        }
      }
    },
    columnDivider: {
      true: {
        container: {
          'border-color': '{primaryGrey40}',
          'border-right-width': 1
        }
      }
    }
  },
  combination: [
    {
      header: {
        true: {
          container: {
            'background-color': '{t_13}',
            'border-color': '{t_14}',
            'border-bottom-width': 0
          },
          'jds-text': {
            'font-family': '{text_91}',
            color: '{text_18}',
            'font-size': '{text_90}',
            'line-height': '{text_92}',
            'letter-spacing': '{text_93}',
            'font-weight': '{text_94}'
          }
        },
        false: {
          container: {
            'border-bottom-width': 4
          },
          'jds-text': {
            'font-family': '{text_91}',
            'font-size': '{text_90}',
            'line-height': '{text_92}',
            'letter-spacing': '{text_93}',
            'font-weight': '{text_94}'
          }
        }
      },
      cell: {
        true: {
          container: {
            'background-color': '{t_15}',
            'border-bottom-width': 0
          }
        }
      }
    }
  ],
  combination_config: [['type', 'background']],
  api: {
    data: {
      'jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    config: {
      type: {
        values: ['cell', 'header']
      },
      density: {
        values: ['relaxed', 'condensed']
      },
      background: {
        values: [false, true]
      },
      columnDivider: {
        values: [false, true]
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            name: '_role'
          }
        }
      }
    }
  }
};
